    if (!customElements.get('cart-delivery-estimate')) {
      customElements.define(
        'cart-delivery-estimate',
        class extends HTMLElement {
          #observer;
          disconnectedCallback() { this.#observer?.disconnect(); }
          connectedCallback() {
            this.#fill();
            // El drawer se re-renderiza (morph) en cada cambio de carrito y vacía el strong: lo rellenamos de nuevo
            this.#observer = new MutationObserver(() => this.#fill());
            this.#observer.observe(this, { childList: true, subtree: true });
          }

          #fill() {
            const target = this.querySelector('[data-delivery-dates]');
            if (!target || target.textContent.trim().length > 1) return;
            const min = this.#addBusinessDays(new Date(), parseInt(this.dataset.minDays, 10) || 3);
            const max = this.#addBusinessDays(new Date(), Math.max(parseInt(this.dataset.minDays, 10) || 3, parseInt(this.dataset.maxDays, 10) || 4));
            const fmt = (d) => d.toLocaleDateString(document.documentElement.lang === 'es' ? 'es-AR' : document.documentElement.lang || 'es-AR', { day: 'numeric', month: 'short' });
            target.textContent = fmt(min) + ' - ' + fmt(max);
          }

          #addBusinessDays(date, days) {
            const result = new Date(date);
            let added = 0;
            while (added < days) {
              result.setDate(result.getDate() + 1);
              const day = result.getDay();
              if (day !== 0 && day !== 6) added++;
            }
            return result;
          }
        }
      );
    }
  
